import React from 'react';
import { shareOrCopy, copyToClipboard, toAbsoluteShareUrl } from '../../utils/share';
import { groupScorerLines } from '../../utils/matchFeed';

// "Saka 82' Isak 31' | Openda 58'": home scorers, then away, pipe-separated.
const buildScorersLine = (scorers) => {
    const sideText = (entries) => groupScorerLines(entries || []).map((line) => line.text).join(' ');
    const parts = [sideText(scorers?.home), sideText(scorers?.away)].filter(Boolean);
    return parts.join(' | ');
};

/**
 * Broadcast-style full time poster with share/copy actions. Renders only for
 * completed matches with a full scoreline; scorers and footer lines drop out
 * when their data is missing.
 */
function MatchSharePanel({ match, scorers, shareUrl }) {
    if (match?.status !== 'completed') return null;

    const homeName = match?.homeTeam?.name;
    const awayName = match?.awayTeam?.name;
    if (!homeName || !awayName) return null;
    if (!Number.isFinite(match?.homeScore) || !Number.isFinite(match?.awayScore)) return null;

    const scoreText = `${match.homeScore} - ${match.awayScore}`;
    const scorersLine = buildScorersLine(scorers);
    const leagueName = match?.league?.name;
    const roundText = match?.round ? `Round ${match.round}` : '';
    const footerLine = [leagueName, roundText].filter(Boolean).join(' | ');

    const handleShare = () => {
        shareOrCopy({
            title: `${homeName} ${scoreText} ${awayName}`,
            text: `Full time: ${homeName} ${scoreText} ${awayName}`,
            url: shareUrl,
        });
    };

    const handleCopyLink = () => {
        copyToClipboard(toAbsoluteShareUrl(shareUrl), 'Match link copied.');
    };

    return (
        <section className="match-share" data-testid="match-share-panel">
            <div className="share-poster">
                <div className="share-poster__kicker">Full time</div>
                <div className="share-poster__scoreline">
                    <span className="share-poster__team">{homeName}</span>
                    <span className="share-poster__score">{scoreText}</span>
                    <span className="share-poster__team">{awayName}</span>
                </div>
                {scorersLine ? <div className="share-poster__scorers">{scorersLine}</div> : null}
                {footerLine ? <div className="share-poster__foot">{footerLine}</div> : null}
            </div>
            <div className="match-share__actions">
                <button type="button" className="gold-cta" onClick={handleShare}>
                    Share result
                </button>
                <button type="button" className="gold-cta gold-cta--ghost" onClick={handleCopyLink}>
                    Copy match link
                </button>
            </div>
        </section>
    );
}

export default MatchSharePanel;
